import { create } from 'zustand';

interface StepUpState {
  open: boolean;
  resolver: ((confirmed: boolean) => void) | null;
  /** Opens the re-authentication dialog; resolves true once /auth/step-up succeeded. */
  request: () => Promise<boolean>;
  settle: (confirmed: boolean) => void;
}

export const useStepUp = create<StepUpState>((set, get) => ({
  open: false,
  resolver: null,
  request: () => {
    const pending = get().resolver;
    // Concurrent 403s share one dialog: chain onto the pending prompt.
    if (pending) {
      return new Promise<boolean>((resolve) => {
        set({
          resolver: (confirmed) => {
            pending(confirmed);
            resolve(confirmed);
          },
        });
      });
    }
    return new Promise<boolean>((resolve) => set({ open: true, resolver: resolve }));
  },
  settle: (confirmed) => {
    const resolver = get().resolver;
    set({ open: false, resolver: null });
    resolver?.(confirmed);
  },
}));
